import { useNavigate } from "react-router-dom";

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20soft%20geometric%20shapes%20in%20warm%20beige%20cream%20sand%20and%20muted%20olive%20tones%2C%20subtle%20fashion%20silhouettes%20blended%20into%20the%20background%2C%20dreamy%20editorial%20aesthetic%2C%20gentle%20gradients%2C%20minimal%20product%20photography%20inspired%2C%20clean%20sophisticated%20atmosphere%2C%20high%20resolution%2C%20elegant%20magazine%20spread%20feel&width=1600&height=1000&seq=hero-bg-v2-2026a&orientation=landscape"
        alt="AllChinaBuy Spreadsheet — curated fashion product database"
        title="Best AllChinaBuy Spreadsheet 2026 — Trusted Product Lists"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />

      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-32 md:py-40">
        <div className="flex flex-col items-center text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white text-xs font-medium mb-8">
            <i className="ri-sparkling-line"></i>
            <span>Updated Weekly — 20,000+ Products</span>
          </div>

          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight tracking-tight mb-6">
            Best AllChinaBuy<br />
            Spreadsheet 2026
          </h1>

          <p className="text-white/80 text-base md:text-lg max-w-xl mt-4 mb-10 leading-relaxed">
            Discover trusted products, verified sellers, quality comparisons, and the latest spreadsheet updates — all in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-white text-foreground-900 font-semibold text-sm hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-black/10"
            >
              AllChinaBuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full border-2 border-white/60 text-white font-semibold text-sm hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
            <button
              onClick={() => navigate("/best-allchinabuy-spreadsheet-guide")}
              className="px-8 py-3.5 rounded-full bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Read Shopping Guide
            </button>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mt-16">
            {[
              { num: "20,000+", label: "Products" },
              { num: "Weekly", label: "Updates" },
              { num: "Trusted", label: "Sellers" },
              { num: "Free", label: "Guides" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-extrabold text-white font-display">
                  {stat.num}
                </div>
                <div className="text-white/60 text-xs md:text-sm mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}